{
  "common": {
    "actions": {
      "cancel": "Cancel",
      "create": "Create",
      "delete": "Delete",
      "edit": "Edit",
      "export": "Export",
      "refresh": "Refresh",
      "save": "Save",
      "view": "View",
      "leave": "Leave",
      "accept": "Accept"
    },
    "errors": {
      "validation_not_unique": "This value is already taken",
      "validation_required": "This field is required",
      "validation_email": "Invalid email format",
      "invalid_credentials": "Invalid email or password",
      "generic": "An error occurred. Please try again.",
      "Something went wrong": "Something went wrong. Please try again later.",
      "Too Many Requests": "Too many requests. Please try again later.",
      "LIMIT.BRANCH.REACHED": "Branch limit has been reached. Upgrade your plan to add more branches.",
      "LIMIT.PATIENT.REACHED": "Patient limit has been reached. Upgrade your plan to add more patients.",
      "LIMIT.APPOINTMENT.REACHED": "Appointment limit has been reached. Upgrade your plan to schedule more appointments.",
      "LIMIT.PROCEDURE_TYPE.REACHED": "Procedure type limit has been reached. Upgrade your plan to add more procedure types.",
      "LIMIT.FORMULARY.REACHED": "Formulary limit has been reached. Upgrade your plan to create more forms.",
      "LIMIT.STORAGE.REACHED": "Storage limit has been reached. Upgrade your plan to get more storage.",
      "LIMIT.DOCTOR.REACHED": "Doctor limit has been reached. Upgrade your plan to add more doctors.",
      "LIMIT.INVITATION.REACHED": "Invitation limit has been reached. Upgrade your plan to invite more doctors.",
      "SUBSCRIPTION.NOT_FOUND": "Subscription not found.",
      "SUBSCRIPTION.INACTIVE": "Subscription is inactive. Please renew your subscription.",
      "SUBSCRIPTION.CANCELLED": "Subscription has been cancelled.",
      "SUBSCRIPTION.EXPIRED": "Subscription has expired.",
      "SUBSCRIPTION.TRIAL_EXPIRED": "Subscription trial has expired.",
      "SUBSCRIPTION.PLAN_NOT_FOUND": "Subscription plan not found.",
      "DEVICE.INFO.INSUFFICIENT": "Device information is insufficient.",
      "DEVICE.COLLECTION.NOT_FOUND": "Device collection not found.",
      "DEVICE.QUERY.FAILED": "Failed to query devices.",
      "DEVICE.SAVE.FAILED": "Failed to save device.",
      "DEVICE.UPDATE.FAILED": "Failed to update device.",
      "INVITATION.ID_REQUIRED": "Invitation ID is required.",
      "INVITATION.INVALID_REQUEST": "Invalid invitation request.",
      "INVITATION.FIRST_NAME_REQUIRED": "First name is required.",
      "INVITATION.LAST_NAME_REQUIRED": "Last name is required.",
      "INVITATION.PHONE_REQUIRED": "Phone number is required.",
      "INVITATION.PASSWORD_REQUIRED": "Password is required.",
      "INVITATION.PASSWORD_MISMATCH": "Passwords do not match.",
      "INVITATION.PASSWORD_WEAK": "Password is too weak. Use at least 8 characters with letters and numbers.",
      "INVITATION.NOT_FOUND": "Invitation not found.",
      "INVITATION.ALREADY_ACCEPTED": "Invitation has already been accepted.",
      "INVITATION.ALREADY_REJECTED": "Invitation has already been rejected.",
      "INVITATION.INVALID_TRANSITION": "This status change is not allowed for the current invitation state.",
      "INVITATION.EXPIRED": "Invitation has expired.",
      "INVITATION.EMAIL_NOT_FOUND": "No invitation found for this email.",
      "INVITATION.DOCTOR_COLL_NOT_FOUND": "Doctor collection not found.",
      "INVITATION.CREATE_DOCTOR_FAILED": "Failed to create doctor account.",
      "INVITATION.ACCEPT_FAILED": "Failed to accept invitation.",
      "INVITATION.RESEND_FAILED": "Failed to resend invitation.",
      "INVITATION.ALREADY_MEMBER": "This user is already a member.",
      "INVITATION.ALREADY_PENDING": "An invitation is already pending for this email.",
      "AUTH.EMAIL_REQUIRED": "Email is required.",
      "AUTH.INVALID_REQUEST": "Invalid authentication request.",
      "AUTH.CODE_NOT_FOUND": "Verification code not found or invalid.",
      "AUTH.CODE_EXPIRED": "Verification code has expired.",
      "AUTH.MISSING_AUTH": "Authentication required.",
      "AUTH.UPDATE_FAILED": "Failed to update authentication.",
      "AUTH.DELETE_FAILED": "Failed to delete authentication.",
      "BRANCH.ID_REQUIRED": "Branch ID is required.",
      "BRANCH.NOT_MEMBER": "You are not a member of this branch.",
      "BRANCH.OWNER_CANNOT_LEAVE": "Branch owner cannot leave the branch.",
      "BRANCH.LEAVE_FAILED": "Failed to leave branch.",
      "BRANCH.NOT_AUTHORIZED": "You are not authorized to perform this action.",
      "BRANCH.MEMBER_NOT_FOUND": "Branch member not found.",
      "BRANCH.CANNOT_REMOVE_OWNER": "Cannot remove the branch owner.",
      "BRANCH.REMOVE_FAILED": "Failed to remove member from branch.",
      "BRANCH.ALREADY_MEMBER": "User is already a member of this branch.",
      "SMS.PHONE_REQUIRED": "Phone number is required.",
      "SMS.SEND_FAILED": "Failed to send SMS.",
      "SMS.COLL_NOT_FOUND": "SMS collection not found.",
      "SMS.CODE_NOT_FOUND": "Verification code not found.",
      "SMS.CODE_UPDATE_FAILED": "Failed to update verification code.",
      "SMS.CODE_SAVE_FAILED": "Failed to save verification code.",
      "WEBHOOK.INVALID_DATA": "Invalid webhook data.",
      "WEBHOOK.MISSING_FIELDS": "Missing required webhook fields.",
      "WEBHOOK.INVALID_SIG": "Invalid webhook signature.",
      "WEBHOOK.READ_FAILED": "Failed to read webhook.",
      "Failed to authenticate": "Please check your email and password and try again.",
      "The request requires valid record authorization token": "Your session has expired. Please log in again.",
      "The request requires valid admin authorization token to be set.": "Admin session has expired. Please log in again.",
      "The request requires valid admin authorization token to be set": "Admin session has expired. Please log in again.",
      "The operation is forbidden": "This action is not allowed.",
      "Something went wrong while processing your request": "Something went wrong. Please try again.",
      "The requested resource wasn't found": "The requested resource was not found or you don't have enough permissions.",
      "Only superusers can perform this action": "Only administrators can perform this action.",
      "Failed to create record": "Failed to create record.",
      "Failed to delete record": "Failed to delete record.",
      "Missing required value": "This field is required.",
      "Invalid filter": "Invalid filter criteria.",
      "Your email is not verified": "Your email address has not been verified.",
      "Invalid login credentials": "Invalid email or password.",
      "UNAUTHORIZED": "You are not authorized to perform this action.",
      "PERMISSION.OWNER_ONLY": "Only the branch owner can perform this action.",
      "DELETE_BLOCKED_BY_RELATION": "Cannot delete: this record is referenced by other records."
    },
    "components": {
      "calendar": {
        "addEvent": "Add Event",
        "appointmentMovedError": "Failed to move appointment",
        "appointmentMovedErrorDescription": "The appointment could not be moved. Please try again.",
        "agenda": {
          "at": "at"
        },
        "dayCell": {
          "more": "More"
        },
        "event": {
          "untitled": "Untitled Event"
        },
        "filters": {
          "all": "All",
          "clear": "Clear Filter",
          "selectUser": "Select user"
        },
        "form": {
          "create": {
            "description": "Fill in the details to create a new event.",
            "status": {
              "error": {
                "message": "There was an error creating the event. Please try again.",
                "title": "Error Creating Event"
              }
            },
            "title": "Create Event"
          },
          "edit": {
            "description": "Modify the details of the event.",
            "status": {
              "error": {
                "message": "There was an error updating the event. Please try again.",
                "title": "Error Updating Event"
              }
            },
            "title": "Edit Event"
          },
          "fields": {
            "color": {
              "label": "Color",
              "placeholder": "Select event color",
              "value": {
                "blue": "Blue",
                "green": "Green",
                "orange": "Orange",
                "purple": "Purple",
                "red": "Red",
                "yellow": "Yellow"
              }
            },
            "doctor": {
              "label": "Doctor"
            },
            "endDate": {
              "label": "End Date"
            },
            "patient": {
              "label": "Patient",
              "placeholder": "Select patient"
            },
            "startDate": {
              "label": "Date"
            },
            "title": {
              "label": "Title",
              "placeholder": "Post-op follow-up consultation"
            },
            "duration": {
              "label": "Duration",
              "minutes": "minutes"
            }
          },
          "patientNotFound": "Patient not found"
        },
        "monthView": {
          "day": "Day",
          "eventBullet": "Event Bullet",
          "of": "of"
        },
        "navigation": {
          "events": "events"
        },
        "settings": {
          "agenda": "Agenda",
          "agendaGroupBy": "Agenda view group by",
          "clock12": "Clock 12",
          "clock24": "Clock 24",
          "color": "Color",
          "date": "Date",
          "day": "Day",
          "defaultView": "Default view",
          "label": "Calendar settings",
          "month": "Month",
          "use24HourFormat": "Use 24 hour format",
          "useDotBadge": "Use dot badge",
          "week": "Week",
          "year": "Year"
        },
        "status": {
          "error": "Error loading calendar",
          "noResultsFound": "No results found."
        },
        "views": {
          "agenda": "Agenda",
          "day": "Day",
          "month": "Month",
          "week": "Week",
          "year": "Year"
        },
        "weekAndDayView": {
          "noAppointments": "No appointments or consultations for today.",
          "switchToDailyOrMonthly": "Please switch to daily or monthly view.",
          "todayAppointments": "Today Appointments",
          "weeklyViewNotAvailable": "Weekly view is not available on smaller devices."
        },
        "yearView": {
          "notAvailable": "Year view not available",
          "switchToDailyOrMonthly": "Switch to daily or monthly view"
        }
      },
      "inputFile": {
        "hasBeenRejected": "File has been rejected",
        "title": "Drag & drop files here",
        "Description": "Or click to browse (max {{maxFiles}} files)",
        "browseFiles": "Browse files",
        "filePreview": "File preview"
      },
      "commandMenu": {
        "search": {
          "description": "Search or navigate",
          "empty": "No results found",
          "placeholder": "Type a command or search...",
          "title": "Search"
        },
        "theme": {
          "options": {
            "dark": "Dark",
            "light": "Light",
            "system": "System"
          },
          "title": "Theme"
        }
      },
      "confirmDialog": {
        "delete": {
          "message": "Are you sure you want to delete this item? This action cannot be undone.",
          "status": {
            "error": {
              "message": "Failed to delete item",
              "title": "Error"
            },
            "loading": {
              "message": "Please wait...",
              "title": "Deleting"
            },
            "success": {
              "message": "Item deleted successfully",
              "title": "Deleted"
            }
          },
          "title": "Confirm deletion"
        },
        "undoDelete": {
          "message": "Do you want to undo the deletion?",
          "title": "Undo deletion",
          "status": {
            "error": {
              "message": "Failed to undo deletion",
              "title": "Error"
            },
            "loading": {
              "message": "Please wait...",
              "title": "Undoing"
            },
            "success": {
              "message": "Item restored successfully",
              "title": "Deletion undone"
            }
          }
        }
      },
      "notificationsDropdown": {
        "created": "Created on {{date}}",
        "title": "Notifications"
      },
      "profileDropdown": {
        "items": {
          "help": "Help",
          "language": "Language",
          "logout": "Sign out",
          "settings": "Settings"
        }
      },
      "search": {
        "placeholder": "Search..."
      },
      "sidebar": {
        "branches": {
          "buttons": {
            "add": "Add branch",
            "select": "Select branch"
          },
          "label": "Branches"
        },
        "groups": {
          "dashboard": "Dashboard",
          "settings": "Settings"
        },
        "items": {
          "appointments": "Appointments",
          "invoices": "Invoices",
          "doctors": "Doctors",
          "branches": "Branches",
          "formularies": "Forms",
          "overview": "Dashboard",
          "patients": "Patients",
          "procedures": "Procedures",
          "proceduresTypes": "Procedures Types"
        }
      },
      "table": {
        "empty": {
          "title": "No results"
        },
        "pagination": {
          "of": "of",
          "page": "Page",
          "rowsPerPage": "Rows per page",
          "selected": "Selected"
        },
        "toolbar": {
          "columns": {
            "empty": "No columns found",
            "search": "Search",
            "title": "Columns"
          },
          "filters": {
            "reset": "Reset"
          }
        }
      }
    },
    "status": {
      "pageError": {
        "action": "Retry",
        "message": "An error occurred while loading the page.",
        "title": "Page error"
      },
      "pageNotFound": {
        "action": "Go back to home",
        "message": "The page you are looking for does not exist.",
        "title": "Page not found"
      },
      "refreshing": "Refreshing...",
      "loading": "Loading..."
    }
  },
  "modules": {
    "appointments": {
      "title": "Appointments"
    },
    "doctors": {
      "title": "Doctors",
      "table": {
        "columns": {
          "search": "Search",
          "photo": "Photo",
          "firstName": "First Name",
          "lastName": "Last Name",
          "email": "Email",
          "phone": "Phone",
          "created": "Created at",
          "doctor": "Doctor"
        }
      },
      "forms": {
        "create": {
          "title": "Create Doctor",
          "description": "Fill in the details to create a new doctor",
          "status": {
            "loading": {
              "title": "Creating doctor",
              "message": "Please wait while we create the doctor..."
            },
            "success": {
              "title": "Doctor created",
              "message": "The doctor has been created successfully"
            },
            "error": {
              "title": "Error creating doctor",
              "message": "An error occurred while creating the doctor"
            }
          }
        },
        "edit": {
          "title": "Edit Doctor",
          "description": "Update doctor details",
          "status": {
            "loading": {
              "title": "Updating doctor",
              "message": "Please wait while we update the doctor..."
            },
            "success": {
              "title": "Doctor updated",
              "message": "The doctor has been updated successfully"
            },
            "error": {
              "title": "Error updating doctor",
              "message": "An error occurred while updating the doctor"
            }
          }
        },
        "fields": {
          "photo": {
            "label": "Profile picture"
          },
          "email": {
            "label": "Email",
            "placeholder": "Enter doctor's email"
          },
          "firstName": {
            "label": "First Name",
            "placeholder": "Enter doctor's first name"
          },
          "lastName": {
            "label": "Last Name",
            "placeholder": "Enter doctor's last name"
          },
          "phoneNumber": {
            "label": "Phone number",
            "placeholder": "Enter doctor's phone number"
          }
        }
      },
      "actions": {
        "removeFromBranch": "Remove from branch"
      },
      "removeFromBranch": {
        "status": {
          "loading": {
            "title": "Removing from branch",
            "message": "Please wait..."
          },
          "success": {
            "title": "Removed from branch",
            "message": "The doctor has been removed from the branch"
          },
          "error": {
            "title": "Error removing from branch",
            "message": "An error occurred while removing the doctor from the branch"
          }
        }
      }
    },
    "auth": {
      "common": {
        "buttons": {
          "back": "Back to home",
          "backToLogin": "Back to login"
        },
        "fields": {
          "email": {
            "label": "Email",
            "placeholder": "jhondoe@email.com"
          },
          "password": {
            "label": "Password",
            "placeholder": "Enter your password"
          },
          "phoneNumber": {
            "label": "Phone number",
            "placeholder": "+1 000 000 000"
          }
        }
      },
      "forgotPassword": {
        "buttons": {
          "register": {
            "question": "Don't have an account?",
            "answer": "Create an account"
          },
          "submit": "Send reset instructions"
        },
        "status": {
          "error": {
            "message": "Please check your email and try again.",
            "title": "Failed to send instructions"
          },
          "loading": {
            "message": "Please wait while we send you reset instructions...",
            "title": "Sending instructions"
          },
          "success": {
            "message": "Check your email for instructions to reset your password.",
            "title": "Instructions sent"
          }
        },
        "title": "Forgot your password?"
      },
      "login": {
        "buttons": {
          "forgotPassword": "Forgot your password?",
          "google": "Sign in with Google",
          "register": {
            "question": "Don't have an account?",
            "answer": "Create an account"
          },
          "submit": "Sign in"
        },
        "status": {
          "error": {
            "message": "Please check your email and password and try again.",
            "title": "Sign in failed"
          },
          "loading": {
            "message": "Please wait while we sign you in...",
            "title": "Signing in"
          },
          "success": {
            "message": "You will be redirected to the dashboard shortly.",
            "title": "Sign in successful"
          }
        },
        "title": "Sign in to your account"
      },
      "register": {
        "buttons": {
          "login": {
            "question": "Already have an account?",
            "answer": "Sign in"
          },
          "submit": "Create account"
        },
        "fields": {
          "passwordConfirm": {
            "label": "Confirm password",
            "placeholder": "Confirm your password"
          }
        },
        "status": {
          "error": {
            "message": "Please check your details and try again.",
            "title": "Registration failed"
          },
          "loading": {
            "message": "Please wait while we create your account...",
            "title": "Creating account"
          },
          "success": {
            "message": "Now you can log in with your new account",
            "title": "Account created successfully"
          }
        },
        "title": "Create an account"
      },
      "resendCode": {
        "status": {
          "error": {
            "message": "Please try again later.",
            "title": "Failed to resend code"
          },
          "loading": {
            "message": "Please wait while we resend the verification code...",
            "title": "Resending code"
          },
          "success": {
            "message": "The verification code has been resent to your phone.",
            "title": "Code resent"
          }
        }
      },
      "sendVerification": {
        "buttons": {
          "logout": "Sign out",
          "submit": "Send verification code"
        },
        "status": {
          "error": {
            "message": "Please check your phone number and try again.",
            "title": "Failed to send code"
          },
          "loading": {
            "message": "Please wait while we send the verification code...",
            "title": "Sending verification code"
          },
          "success": {
            "message": "Check your phone for the verification code.",
            "title": "Verification code sent"
          }
        },
        "title": "Send verification code"
      },
      "verifyPhone": {
        "buttons": {
          "logout": "Sign out",
          "resendCode": "Resend code",
          "submit": "Verify phone number"
        },
        "fields": {
          "otp": {
            "label": "Verification code"
          }
        },
        "status": {
          "error": {
            "message": "Please check the code and try again.",
            "title": "Verification failed"
          },
          "loading": {
            "message": "Please wait while we verify your phone number...",
            "title": "Verifying phone number"
          },
          "success": {
            "message": "Your phone number has been verified successfully.",
            "title": "Phone number verified"
          }
        },
        "title": "Verify your phone number"
      }
    },
    "invoices": {
      "actions": {
        "addItem": {
          "description": "There are no articles on this invoice. Click on 'Add article' to add one.",
          "title": "Add item"
        },
        "print": {
          "status": {
            "error": {
              "message": "An error occurred while printing",
              "title": "Print failed"
            },
            "loading": {
              "message": "Please wait while we print...",
              "title": "Printing invoice"
            },
            "noItems": {
              "message": "No items to print",
              "title": "No items"
            },
            "success": {
              "message": "The invoice has been printed successfully",
              "title": "Invoice printed"
            }
          },
          "title": "Print Invoice"
        }
      },
      "common": {
        "terms": {
          "statusOptions": {
            "generated": "Generated",
            "paid": "Paid",
            "cancelled": "Cancelled"
          }
        }
      },
      "forms": {
        "create": {
          "description": "Fill in the details to create a new invoice",
          "title": "Create Invoice",
          "status": {
            "error": {
              "message": "An error occurred while creating the invoice",
              "title": "Create failed"
            },
            "loading": {
              "message": "Please wait while we create the invoice...",
              "title": "Creating invoice..."
            },
            "success": {
              "message": "The invoice has been created successfully",
              "title": "Invoice created"
            }
          }
        },
        "edit": {
          "description": "Update invoice details",
          "status": {
            "error": {
              "message": "An error occurred while updating the invoice",
              "title": "Update failed"
            },
            "loading": {
              "message": "Please wait while we update the invoice...",
              "title": "Updating invoice"
            },
            "success": {
              "message": "The invoice has been updated successfully",
              "title": "Invoice updated"
            }
          },
          "title": "Edit Invoice"
        },
        "fields": {
          "patient": {
            "label": "Patient",
            "placeholder": "Select patient"
          },
          "price": {
            "label": "Price",
            "placeholder": "Procedure price"
          },
          "procedure": {
            "label": "Procedure",
            "placeholder": "Procedure name"
          },
          "status": {
            "label": "Status",
            "placeholder": "Select status"
          }
        }
      },
      "table": {
        "columns": {
          "created": "Created at",
          "doctor": "Doctor",
          "patient": "Patient",
          "search": "Search",
          "status": "Status",
          "total": "Total"
        }
      },
      "title": "Invoice"
    },
    "branches": {
      "terms": {
        "role": "Role",
        "main": "Main branch",
        "owner": "Owner",
        "guest": "Guest",
        "settings": "Settings"
      },
      "forms": {
        "create": {
          "title": "Create Branch",
          "description": "Fill in the details to create a new branch",
          "status": {
            "error": {
              "message": "An error occurred while creating the branch",
              "title": "Creation failed"
            },
            "loading": {
              "message": "Please wait while we create the branch...",
              "title": "Creating branch"
            },
            "success": {
              "message": "The branch has been created successfully",
              "title": "Branch created"
            }
          }
        },
        "edit": {
          "description": "Update branch details",
          "status": {
            "error": {
              "message": "An error occurred while updating the branch",
              "title": "Update failed"
            },
            "loading": {
              "message": "Please wait while we update the branch...",
              "title": "Updating branch"
            },
            "success": {
              "message": "The branch has been updated successfully",
              "title": "Branch updated"
            }
          },
          "title": "Edit Branch"
        },
        "fields": {
          "address": {
            "label": "Address",
            "placeholder": "Street, number and city"
          },
          "email": {
            "label": "Email",
            "placeholder": "jhondoe@email.com"
          },
          "phoneNumber": {
            "label": "Phone Number",
            "placeholder": "+1 000 000 000"
          },
          "file": {
            "label": "File"
          },
          "image": {
            "label": "Branch Image"
          },
          "name": {
            "label": "Branch Name",
            "placeholder": "Northern Branch"
          }
        }
      },
      "table": {
        "columns": {
          "created": "Created at",
          "doctor": "Doctor",
          "email": "Email",
          "image": "Image",
          "name": "Name",
          "phone": "Phone",
          "role": "Role",
          "search": "Search"
        }
      },
      "title": "Branches"
    },
    "dashboard": {
      "charts": {
        "monthComparison": {
          "comparedToLastMonth": "Compared to last month",
          "description": "Compare current month with previous months",
          "lastMonth": "Last Month",
          "thisMonth": "This Month",
          "title": "Monthly Comparison"
        },
        "overview": {
          "title": "Activity Summary",
          "description": "Monthly statistics of doctor activities",
          "error": {
            "message": "An error occurred while loading statistics. Please try again later.",
            "title": "Error loading statistics"
          },
          "quantity": "Quantity",
          "modules": {
            "revenue": "Revenue",
            "patients": "Patients",
            "appointments": "Appointments",
            "appointmentsCancelled": "Appointments Cancelled",
            "procedures": "Procedures",
            "invoicesGenerated": "Invoices Generated",
            "invoicesPaid": "Invoices Paid",
            "invoicesCancelled": "Invoices Cancelled",
            "avgAppointmentDuration": "Average Appointment Duration"
          }
        },
        "newPatients": {
          "description": "List of newly added patients",
          "empty": {
            "message": "There are no patients who have been added recently",
            "title": "No new patients"
          },
          "title": "New patients"
        },
        "statistics": {
          "title": "Performance Statistics",
          "periods": {
            "currentMonth": "Current Month",
            "currentYear": "Current Year"
          },
          "metrics": {
            "patients": "Patients",
            "appointments": "Appointments",
            "procedures": "Procedures",
            "invoices": "Invoices",
            "revenue": "Revenue"
          }
        }
      },
      "title": "dashboard"
    },
    "documents": {
      "title": "Documents",
      "forms": {
        "create": {
          "description": "Upload a new document",
          "status": {
            "error": {
              "message": "An error occurred while creating the document",
              "title": "Error creating document"
            },
            "loading": {
              "message": "Please wait while we create the document...",
              "title": "Creating document"
            },
            "success": {
              "message": "The document has been created successfully",
              "title": "Document created"
            }
          },
          "title": "Create document"
        },
        "edit": {
          "description": "Update document information",
          "status": {
            "error": {
              "message": "An error occurred while updating the document",
              "title": "Error updating document"
            },
            "loading": {
              "message": "Please wait while we update the document...",
              "title": "Updating document"
            },
            "success": {
              "message": "The document has been updated successfully",
              "title": "Document updated"
            }
          },
          "title": "Edit document"
        },
        "fields": {
          "name": {
            "label": "Document name",
            "placeholder": "Laboratory results"
          }
        }
      },
      "table": {
        "columns": {
          "created": "Creation date",
          "document": "Document",
          "name": "Name",
          "search": "Search",
          "size": "Size"
        }
      }
    },
    "formularies": {
      "actions": {
        "addFields": {
          "title": "Add fields"
        }
      },
      "forms": {
        "create": {
          "description": "Create medical form",
          "status": {
            "error": {
              "message": "An error occurred when creating the form",
              "title": "Error creating form"
            },
            "loading": {
              "message": "Please wait while we create the form ...",
              "title": "Creating form"
            },
            "success": {
              "message": "The form has been created successfully",
              "title": "Created form"
            }
          },
          "title": "Create medical form"
        },
        "edit": {
          "description": "Update form details",
          "status": {
            "error": {
              "message": "An error occurred when creating the form",
              "title": "Error creating formulary"
            },
            "loading": {
              "message": "Please wait while we update the form ...",
              "title": "Updating the form"
            },
            "success": {
              "message": "The form has been successfully updated",
              "title": "Updated form"
            }
          },
          "title": "Edit form"
        },
        "fields": {
          "description": {
            "label": "Description",
            "placeholder": "This document collects the medical and dental history of the patient before starting any physical examination."
          },
          "fields": {
            "label": "Fields",
            "placeholder": "Select the Form fields"
          },
          "name": {
            "label": "Name of the form",
            "placeholder": "Anamnesis Form"
          }
        }
      },
      "responses": {
        "create": {
          "status": {
            "error": {
              "title": "Error creating response"
            },
            "loading": {
              "message": "Please wait while we create the response...",
              "title": "Creating response"
            },
            "success": {
              "message": "The response has been created successfully",
              "title": "Response created"
            }
          }
        },
        "update": {
          "status": {
            "error": {
              "title": "Error updating response"
            },
            "loading": {
              "message": "Please wait while we update the response...",
              "title": "Updating response"
            },
            "success": {
              "message": "The response has been updated successfully",
              "title": "Response updated"
            }
          }
        }
      },
      "table": {
        "columns": {
          "created": "Created at",
          "description": "Description",
          "doctor": "Doctor",
          "name": "Name",
          "search": "Search"
        }
      },
      "title": "formularies"
    },
    "patients": {
      "details": {
        "birthDate": "Birth date",
        "createdAt": "Registration date",
        "email": "Email",
        "phone": "Phone",
        "subtitle": "Patient information"
      },
      "forms": {
        "create": {
          "description": "Fill in the details to create a new patient",
          "status": {
            "error": {
              "message": "An error occurred when creating the patient",
              "title": "Error when creating"
            },
            "loading": {
              "message": "Please wait while we create the patient ...",
              "title": "Creating patient"
            },
            "success": {
              "message": "The patient has been created successfully",
              "title": "Created patient"
            }
          },
          "title": "Create Patient"
        },
        "edit": {
          "description": "Update patient details",
          "status": {
            "error": {
              "message": "An error occurred when updating the patient",
              "title": "Error when updating"
            },
            "loading": {
              "message": "Please wait while we update the patient ...",
              "title": "Updating patient"
            },
            "success": {
              "message": "The patient has been successfully updated",
              "title": "Updated patient"
            }
          },
          "title": "Update patient"
        },
        "fields": {
          "photo": {
            "label": "Photo",
            "placeholder": "Enter the patient photo"
          },
          "bornDate": {
            "label": "Born date",
            "placeholder": "patient born date"
          },
          "email": {
            "label": "Email",
            "placeholder": "johndoe@email.com"
          },
          "firstName": {
            "label": "First name",
            "placeholder": "John"
          },
          "lastName": {
            "label": "Last name",
            "placeholder": "Doe"
          },
          "phoneNumber": {
            "label": "Phone",
            "placeholder": "+1 (555) 555-5555"
          },
          "doctor": {
            "label": "Doctor",
            "placeholder": "Select doctor"
          }
        }
      },
      "medicalHistory": {
        "clearSearch": "Clear",
        "noDescription": "No description available",
        "noFormularies": "No forms found",
        "search": "Search",
        "selectMedicalForm": "Select Medical Form",
        "selectMedicalFormDescription": "Select the medical form to associate with the appointment."
      },
      "table": {
        "columns": {
          "created": "Create at",
          "doctor": "Doctor",
          "email": "Email",
          "firstName": "Name",
          "photo": "Photo",
          "lastName": "Last name",
          "phoneNumber": "Phone",
          "search": "Search"
        }
      },
      "tabs": {
        "appointments": "Appointments",
        "documents": "Documents",
        "medicalHistory": "Medical History",
        "procedures": "Procedures"
      },
      "title": "Patients"
    },
    "procedures": {
      "forms": {
        "create": {
          "title": "Create procedure",
          "description": "Please fill in the required fields to create the procedure",
          "status": {
            "error": {
              "message": "An error occurred when creating the procedure",
              "title": "Error when creating procedure"
            },
            "loading": {
              "message": "Please wait while we create the procedure ...",
              "title": "Creating procedure"
            },
            "success": {
              "message": "The procedure has been created successfully",
              "title": "Created procedure"
            }
          }
        },
        "edit": {
          "description": "Update procedure details",
          "status": {
            "error": {
              "message": "An error occurred when loading the procedure",
              "title": "Error when loading procedure"
            },
            "loading": {
              "message": "Please wait while we load the procedure ...",
              "title": "Loading procedure"
            },
            "success": {
              "message": "The procedure has been successfully charged",
              "title": "Loaded procedure"
            }
          },
          "title": "Update procedure"
        },
        "fields": {
          "doctor": {
            "label": "Doctor",
            "placeholder": "Select doctor"
          },
          "patient": {
            "label": "Patient",
            "placeholder": "Select patient"
          },
          "type": {
            "label": "Procedure type",
            "placeholder": "Select procedure type"
          }
        }
      },
      "table": {
        "columns": {
          "created": "Created at",
          "doctor": "Doctor",
          "patient": "Patient",
          "search": "Search",
          "type": "Type"
        }
      },
      "title": "procedures"
    },
    "proceduresTypes": {
      "forms": {
        "create": {
          "title": "Create procedure type",
          "description": "Create a new procedure type",
          "status": {
            "error": {
              "message": "An error occurred when creating the procedure type",
              "title": "Error when creating procedure type"
            },
            "loading": {
              "message": "Please wait while we create the procedure type ...",
              "title": "Creating procedure type"
            },
            "success": {
              "message": "The procedure type has been created successfully",
              "title": "Created procedure type"
            }
          }
        },
        "edit": {
          "description": "Update procedure type details",
          "status": {
            "error": {
              "message": "An error occurred when loading the procedure type",
              "title": "Error when loading procedure type"
            },
            "loading": {
              "message": "Please wait while we load the procedure type ...",
              "title": "Loading procedure type"
            },
            "success": {
              "message": "The procedure type has been successfully charged",
              "title": "Loaded procedure type"
            }
          },
          "title": "Update procedure type"
        },
        "fields": {
          "description": {
            "label": "Description",
            "placeholder": "Review of routine and initial diagnosis of the patient."
          },
          "duration": {
            "label": "Duration",
            "placeholder": "Duration of the procedure type"
          },
          "name": {
            "label": "Name",
            "placeholder": "General consultation"
          }
        }
      },
      "table": {
        "columns": {
          "created": "Created at",
          "description": "Description",
          "duration": "Duration",
          "name": "Name",
          "search": "Search"
        }
      },
      "title": "procedures types"
    },
    "settings": {
      "title": "Settings",
      "billing": {
        "description": "Manage billing information and payment methods",
        "nextBillingDate": "Next billing date",
        "monthly": "Monthly",
        "paymentMethod": "Payment method",
        "plan": "Plan",
        "subscription": "Subscription",
        "title": "Billing Settings",
        "manageSubscription": "Manage subscription",
        "subscriptionTracker": {
          "title": "Subscription Status",
          "trial": "Trial Period",
          "trialDescription": "Upgrade to unlock all features",
          "active": "Active",
          "activeDescription": "Your subscription is active and running smoothly.",
          "activeStatus": "Active",
          "pausedStatus": "Paused",
          "endsAt": "Ending Soon",
          "endsAtDescription": "Your subscription is about to end.",
          "daysLeft": "days left",
          "startedIn": "Started in",
          "endsAtDate": "Ends in",
          "upgrade": "Upgrade",
          "expired": "Expired"
        },
        "planLimits": {
          "title": "Plan Usage",
          "description": "Current resource usage for your plan",
          "upgrade": "Upgrade Plan",
          "unlimited": "Unlimited",
          "resources": {
            "patients": "Patients",
            "branches": "Branches",
            "doctors": "Doctors",
            "appointmentsMonth": "Appointments (month)",
            "procedureTypes": "Procedure Types",
            "formularies": "Formularies",
            "storageMB": "Storage (MB)"
          },
          "alerts": {
            "limitReached": "Limit reached",
            "nearLimit": "Near limit",
            "upgradeMessage": "You have reached the limit of your plan. Upgrade to continue."
          }
        }
      },
      "subscription": {
        "expired": {
          "title": "Subscription expired",
          "message": "Your subscription has ended. Renew your plan to continue using all features."
        },
        "past_due": {
          "title": "Payment overdue",
          "message": "You have a pending payment. Update your payment method to avoid service suspension."
        },
        "unpaid": {
          "title": "Payment required",
          "message": "Your subscription is not paid. Make a payment to continue using the service."
        },
        "cancelled": {
          "title": "Subscription cancelled",
          "message": "Your subscription was cancelled. You can reactivate it at any time."
        },
        "paused": {
          "title": "Subscription paused",
          "message": "Your subscription is paused. Reactivate it to continue using all features."
        },
        "trial_expired": {
          "title": "Trial period ended",
          "message": "Your trial period has ended. Subscribe to continue using all features."
        },
        "button": "Manage subscription"
      },
      "devices": {
        "buttons": {
          "currentDevice": "Current device",
          "logout": "Log out"
        },
        "description": "Manage devices connected to your account",
        "forms": {
          "edit": {
            "status": {
              "error": {
                "message": "An error occurred while logging out the device",
                "title": "Error logging out"
              },
              "loading": {
                "message": "Please wait while we log out this device...",
                "title": "Logging out device"
              },
              "success": {
                "message": "The device session has been ended successfully",
                "title": "Session ended"
              }
            }
          },
          "create": {
            "title": "Create new device",
            "description": "Create a new device",
            "fields": {
              "name": {
                "label": "Device name",
                "placeholder": "Enter the device name"
              },
              "userAgent": {
                "label": "User Agent",
                "placeholder": "Enter the User Agent"
              }
            }
          }
        },
        "lastAccessed": "Last accessed",
        "on": "on",
        "title": "Device Management"
      },
      "profile": {
        "forms": {
          "changeEmail": {
            "description": "Update your email address",
            "fields": {
              "currentPassword": {
                "label": "Current password",
                "placeholder": "Enter your current password"
              },
              "newEmail": {
                "label": "New email address",
                "placeholder": "Enter your new email"
              }
            },
            "status": {
              "error": {
                "message": "An error occurred while changing your email address",
                "title": "Error changing email"
              },
              "loading": {
                "message": "Please wait while we process the change...",
                "title": "Changing email address"
              },
              "success": {
                "message": "Your email address has been updated successfully",
                "title": "Email address updated"
              }
            },
            "title": "Change Email Address"
          },
          "changePassword": {
            "description": "Update your access password",
            "fields": {
              "confirmPassword": {
                "label": "Confirm new password",
                "placeholder": "Confirm your new password"
              },
              "newPassword": {
                "label": "New password",
                "placeholder": "Enter your new password"
              },
              "currentPassword": {
                "label": "Current password",
                "placeholder": "Enter your current password"
              }
            },
            "status": {
              "error": {
                "message": "An error occurred while changing your password",
                "title": "Error changing password"
              },
              "loading": {
                "message": "Please wait while we update your password...",
                "title": "Changing password"
              },
              "success": {
                "message": "Your password has been updated successfully",
                "title": "Password updated"
              }
            },
            "title": "Change Password"
          },
          "update": {
            "description": "Modify your personal information",
            "fields": {
              "photo": {
                "label": "Profile picture"
              },
              "firstName": {
                "label": "Full first name",
                "placeholder": "Enter your first name"
              },
              "lastName": {
                "label": "Full last name",
                "placeholder": "Enter your last name"
              },
              "phoneNumber": {
                "label": "Full phone number",
                "placeholder": "Enter your phone number"
              }
            },
            "status": {
              "error": {
                "message": "An error occurred while updating your profile",
                "title": "Error updating profile"
              },
              "loading": {
                "message": "Please wait while we update your profile...",
                "title": "Updating profile"
              },
              "success": {
                "message": "Your profile has been updated successfully",
                "title": "Profile updated"
              }
            },
            "title": "Update Profile"
          }
        }
      }
    },
    "support": {
      "description": "Submit a support ticket for assistance",
      "form": {
        "fields": {
          "email": {
            "label": "Email",
            "placeholder": "Type your email address"
          },
          "message": {
            "label": "Message",
            "placeholder": "Describe your issue or question"
          },
          "subject": {
            "label": "Subject",
            "placeholder": "Enter ticket subject"
          }
        },
        "status": {
          "error": {
            "message": "Failed to load tickets",
            "title": "Error"
          },
          "loading": {
            "message": "Please wait...",
            "title": "Loading tickets"
          },
          "success": {
            "message": "Tickets loaded successfully",
            "title": "Success"
          }
        }
      },
      "title": "Support"
    },
    "invitations": {
      "title": "Invitations",
      "description": "Manage doctor invitations to your branch",
      "sent": {
        "title": "Sent Invitations",
        "description": "Manage invitations you've sent to other doctors",
        "empty": "You haven't sent any invitations"
      },
      "received": {
        "title": "Received Invitations",
        "description": "Review invitations you've received",
        "empty": "You have no pending invitations"
      },
      "statuses": {
        "pending": "Pending",
        "accepted": "Accepted",
        "rejected": "Rejected",
        "expired": "Expired"
      },
      "invitedBy": "Invited by",
      "invitedTo": "Invited to",
      "branch": "Branch",
      "created": "Created",
      "expires": "Expires",
      "buttons": {
        "accept": "Accept",
        "accepting": "Accepting...",
        "reject": "Reject",
        "cancel": "Cancel",
        "resend": "Resend",
        "invite": "Invite Doctor"
      },
      "acceptDialog": {
        "title": "Accept Invitation"
      },
      "status": {
        "loading": {
          "title": "Updating invitation",
          "message": "Please wait..."
        },
        "success": {
          "title": "Invitation updated",
          "message": "The invitation was updated successfully"
        },
        "error": {
          "title": "Error updating invitation",
          "message": "An error occurred while updating the invitation"
        }
      },
      "resend": {
        "loading": {
          "title": "Resending invitation",
          "message": "Please wait..."
        },
        "success": {
          "title": "Invitation resent",
          "message": "The invitation was resent successfully"
        },
        "error": {
          "title": "Error resending invitation",
          "message": "An error occurred while resending the invitation"
        }
      },
      "delete": {
        "loading": {
          "title": "Canceling invitation",
          "message": "Please wait..."
        },
        "success": {
          "title": "Invitation canceled",
          "message": "The invitation was canceled successfully"
        },
        "error": {
          "title": "Error canceling invitation",
          "message": "An error occurred while canceling the invitation"
        }
      },
      "forms": {
        "create": {
          "title": "Invite Doctor",
          "description": "Send an invitation to another doctor to join your branch",
          "fields": {
            "email": {
              "label": "Doctor's Email",
              "placeholder": "Enter doctor's email"
            },
            "branch": {
              "label": "Branch",
              "placeholder": "Select a branch"
            },
            "message": {
              "label": "Message (optional)",
              "placeholder": "Add a custom message"
            }
          },
          "buttons": {
            "submit": "Send Invitation",
            "submitting": "Sending...",
            "cancel": "Cancel"
          },
          "errors": {
            "doctorNotFound": "No doctor found with this email. The doctor must register first.",
            "cannotInviteSelf": "You cannot invite yourself."
          },
          "status": {
            "loading": {
              "title": "Sending invitation",
              "message": "Please wait..."
            },
            "success": {
              "title": "Invitation sent",
              "message": "The invitation was sent successfully"
            },
            "error": {
              "title": "Error sending invitation",
              "message": "An error occurred while sending the invitation"
            }
          }
        }
      },
      "invitationPage": {
        "title": "You've Been Invited!",
        "subtitle": "Join to {{branchName}}",
        "personalMessage": "Personal message",
        "validUntil": "Valid until",
        "fields": {
          "email": {
            "label": "Email"
          },
          "firstName": {
            "label": "First Name",
            "placeholder": "Enter your first name"
          },
          "lastName": {
            "label": "Last Name",
            "placeholder": "Enter your last name"
          },
          "phoneNumber": {
            "label": "Phone Number",
            "placeholder": "Enter your phone number"
          },
          "password": {
            "label": "Password",
            "placeholder": "Create a strong password"
          },
          "confirmPassword": {
            "label": "Confirm Password",
            "placeholder": "Confirm your password"
          }
        },
        "infoText": "By accepting this invitation, you'll be able to collaborate with the office team and access all platform features.",
        "buttons": {
          "acceptInvitation": "Accept Invitation",
          "rejectInvitation": "Reject Invitation",
          "creatingAccount": "Creating Account...",
          "goToDashboard": "Go to Dashboard"
        },
        "loading": "Loading invitation...",
        "notFound": {
          "title": "Invitation Not Found",
          "description": "This invitation does not exist or you don't have permission to view it."
        },
        "status": {
          "accepted": {
            "title": "Invitation Accepted",
            "message": "You have successfully joined to {{branchName}}!",
            "description": "You can now access the office dashboard and start collaborating with your team."
          },
          "rejected": {
            "title": "Invitation Declined",
            "message": "This invitation to join {{branchName}} was declined."
          },
          "expired": {
            "title": "Invitation Expired",
            "message": "This invitation to join {{branchName}} has expired.",
            "expiredOn": "Expired on: {{date}}",
            "description": "Please request a new invitation."
          }
        },
        "toast": {
          "acceptLoading": "Accepting invitation",
          "acceptSuccess": "Invitation accepted successfully!",
          "acceptError": "Failed to accept invitation",
          "rejectLoading": "Rejecting invitation",
          "rejectSuccess": "Invitation rejected successfully!",
          "rejectError": "Failed to reject invitation"
        },
        "validation": {
          "passwordMismatch": "Passwords do not match"
        }
      }
    }
  }
}
